module.exports = __webpack_public_path__ + "img/smsnikita.d8b374ad.png";